<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline title="Term Mapping">
        <v-card flat class="px-2">
          <form @submit.prevent="Save">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Academic Year <span class="error--text">*</span></label>
                <v-autocomplete class="my-0 py-1" placeholder="--Select--" v-model="academicYearID" required :items="academicYears" key="id" item-value="id" item-text="academicYear"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Select classes
                  <span class="requir error--text">*</span>
                </label>
                <multiselect
                  class="overflowmultiselect2"
                  label="name"
                  track-by="id"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :multiple="true"
                  :options="classes"
                  v-model="classID"
                >
                </multiselect>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2"> Select Franchisee <span class="requir error--text">*</span></label>
                <div class="level-left"><b-checkbox v-model="flag" @input="allFranchisee"></b-checkbox>All Franchisee</div>
                <multiselect
                  class="overflowmultiselect2"
                  label="companyName"
                  track-by="companyName"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :multiple="true"
                  :options="franchiseeArr"
                  v-model="selectedFranchisee"
                >
                </multiselect>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Select Academic Term <span class="error--text">*</span></label>
                <v-autocomplete class="my-0 py-1" placeholder="--Select--" required v-model="term" :items="terms" key="id" item-value="id" item-text="name"> </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">From Date <span class="error--text">*</span></label>
                <custom-date-picker v-model="fromDate" required />
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">To Date <span class="error--text">*</span></label>
                <custom-date-picker :minToDate="fromDate" v-model="toDate" required />
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn :disabled="hasClicked" bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '@/components/template/CustomDatePicker'
import Utils from '@/utils'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
export default {
  name: 'addTerm',
  components: {
    Multiselect,
    MaterialCard,
    CustomDatePicker
  },
  data () {
    return {
      academicYearID: '',
      academicYears: [],
      selectedFranchisee: [],
      franchiseeArr: [],
      classID: [],
      classes: [],
      terms: [],
      term: '',
      fromDate: '',
      toDate: '',
      flag: '',
      hasClicked: false,
      loader: true,
      inProgress: false,
      isLoading: false,
      maxToDate: moment().format('YYYY-MM-DD')
    }
  },
  async created () {
    await this.getFranchiseeList()
    await this.getYear()
    await this.termList()
  },

  methods: {
    getFranchiseeList: async function () {
      try {
        this.isLoading = true
        const response = await http.get(`${constants.API_URL}/api/franchisee/active`)
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)

        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      } finally {
        this.isLoading = false
      }
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=false`)
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find(y => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    termList: async function () {
      try {
        const studentclasses = await http.get(`${constants.API_URL}/api/students/class`)
        this.classes = studentclasses.data.rows
        const Terms = await http.get(`${constants.API_URL}/api/grade-module/academic-terms`)
        this.terms = Terms.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    allFranchisee: function () {
      let franchiseeArray = []
      if (this.flag === true) {
        this.franchiseeArr.forEach(Obj => {
          franchiseeArray.push(Obj)
        })
        this.flag = true
      }
      this.selectedFranchisee = franchiseeArray
    },
    Save: async function () {
      if (this.classID.length === 0) {
        return this.$dialog.message.warning('Please select class', {
          position: 'top',
          timeout: 4000
        })
      }
      if (this.selectedFranchisee.length === 0) {
        return this.$dialog.message.warning('Please select Franchisee', {
          position: 'top',
          timeout: 4000
        })
      }
      let p = this.selectedFranchisee.map(a => a.id)
      let q = this.classID.map(b => b.id)
      let sendData = {
        franchiseeID: p,
        classID: q,
        academicYearID: this.academicYearID,
        academicTermID: this.term,
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      this.hasClicked = true
      try {
        let responce = await http.post(`${constants.API_URL}/api/grade-module/academic-terms/date/map`, sendData)
        this.loader = false
        this.$router.push({ name: 'termDetails' })
        return this.$dialog.info({
          title: 'Success',
          text: responce.data[0][0] || 'Saved successfully'
        })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Saving Enquiry Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    }
    // check: async function () {

    // }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
